<template>
  <el-form-item
    :label="label"
    class="charge-year"
    :prop="prop"
    :rules="rules"
  >
    <el-select
      v-model="chargeYear"
      :placeholder="placeholder"
      :disabled="disabled"
      :autofocus="autofocus"
      :clearable="false"
      :filterable="false"
      :filter-method="filter"
    >
      <el-option v-if='mode !== "this"' label="" value="" />
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.value"
        :value="item.value"
      >
      </el-option>
    </el-select>
  </el-form-item>
</template>

<script>
import Validator from '@/mixins/Validator.vue'

export default {
  components: {},
  model: {
    event: 'change'
  },
  mixins: [
    Validator
  ],
  props: {
    value: String,
    label: {
      type: String,
      default: '料金年度'
    },
    prop: {
      type: String,
      default: ''
    },
    mode: {
      type: String,
      default: 'search'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    initialize: {
      type: Boolean,
      default: false
    },
    searchCond: {
      type: Boolean,
      default: false
    },
    tableType: {
      type: String,
      default: ''
    },
    yearType: {
      type: String,
      default: ''
    },
    selectedIndex: {
      type: Number,
      default: -1
    }
  },
  data () {
    return {
      options: [],
      optionsOriginal: [],
      placeholder: ''
    }
  },
  computed: {
    chargeYear: {
      get () {
        return this.value
      },
      set (chargeYear) {
        this.$emit('change', chargeYear)
      }
    },
    rules: {
      get () {
        const rules = []
        if (!this.disabled) {
          if (this.required) {
            rules.push(this.validatorRequired(this.label, 'change'))
          }
        }
        return rules
      }
    }
  },
  async mounted () {
    var chargeYear = {}
    var chargeYearSet = {}
    if (this.yearType === 'reference') {
      chargeYear = await this.loadChargeYear()
    } else if (this.yearType === 'create') {
      chargeYear = await this.loadChargeYearFromSystem()
    }
    chargeYearSet = chargeYear.map(function (index, array) {
      return { value: index.charge_year, label: index.charge_year }
    })
    this.options = chargeYearSet
    this.optionsOriginal = chargeYearSet

    // 最大値をデフォルト値とする
    if (this.options.length > 0) {
      if (this.selectedIndex >= 0) {
        // this.chargeYear = this.options[0].value
        this.chargeYear = this.options[this.selectedIndex].value
      }
    }
  },
  methods: {
    // DBから料金年度を取得
    async loadChargeYear () {
      if (this.initialize) {
        await this.$axios
          .get('/charge_year', { params: { table_type: this.tableType } })
          .then((res) => {
            sessionStorage.setItem('charge_year', JSON.stringify(res.data.list))
          })
          .catch((e) => {
            console.log(e)
          })
      }
      return JSON.parse(sessionStorage.getItem('charge_year'))
    },
    // システム日付から料金年度を取得
    async loadChargeYearFromSystem () {
      if (this.initialize) {
        // システム日付から料金年度を取得（年度 = 今月の3ヶ月前の年）
        var date = new Date()
        date.setMonth(date.getMonth() - 3)
        var defaultYEAR = date.getFullYear()

        // 料金年度リストを作成
        // 検索用:デフォルト料金年度+1ヵ月
        var createYearList = []
        createYearList.push({ charge_year: String(defaultYEAR + 1) })
        createYearList.push({ charge_year: String(defaultYEAR) })

        sessionStorage.setItem('create_year', JSON.stringify(createYearList))
      }
      return JSON.parse(sessionStorage.getItem('create_year'))
    },
    filter (a) {
      this.options = this.optionsOriginal.filter((x) => {
        return x.value.toLowerCase().indexOf(a.toLowerCase()) === 0 || x.label.toLowerCase().indexOf(a.toLowerCase()) === 0
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.charge-year {
  ::v-deep .el-form-item__content {
    width: 8em;
  }
}
.el-select-dropdown__item span {
  padding-left: 5px;
  padding-right: 5px;
}
</style>
